// extracted by mini-css-extract-plugin
export default {"layout":"Resume_layout__L8UZL","themeOption":"Resume_themeOption__DOn6m"};